
import { Component, Getter, Vue } from 'bits/vue'
import { getWallAccessPrivacyTypeName, getWallAccessPrivacyTypeText } from 'bits/wall_access_settings_helper'
import { LibraryType, WallAccessPrivacyType } from 'enums'
import BaseIcon from 'vuecomponents/base_icon.vue'
import EscapeToCancelMixin from 'vuemixins/escape_to_cancel_mixin'

@Component({
  components: { BaseIcon },
  mixins: [EscapeToCancelMixin],
})
export default class PrivacyInfo extends Vue {
  @Getter isLibraryWall!: boolean
  @Getter isOrgWall!: boolean
  @Getter organizationName!: string
  @Getter libraryType?: LibraryType

  WallAccessPrivacyType = WallAccessPrivacyType

  get wallAccessPrivacyTypeText(): { [key in WallAccessPrivacyType]: string } {
    return getWallAccessPrivacyTypeText({
      organization: this.organizationName,
    })
  }

  get wallAccessPrivacyTypeLongName(): { [key in WallAccessPrivacyType]: string } {
    return getWallAccessPrivacyTypeName({
      libraryType: this.libraryType,
      length: 'long',
    })
  }

  cancel(): void {
    this.$emit('close')
  }
}
